import { ParameterOptionValue } from '@app/core/helpers/data-reports-generator.helper';
import { MainRoutes } from '@app/shared/enums/general.enums';
import { OrganizationRoute } from '@app/pages/organization/enums/organization.enums';
import { Params } from '@angular/router';
import { mapParamsToRequest } from '@app/core/helpers/helpers.helper';
import { ITEM_TO_PARAM_MAP } from '@app/shared/components/new-drawer/search/helper/search-drawer.helper';
import { SearchOptionsValue } from '@app/shared/components/new-drawer/new-drawer.enums';

export interface SearchDrawerNormalizedData {
	route: string;
	searchParams: any; // TODO: use type.
}

// This map is responsible of the route names that the user should be navigate to after the search button is clicked.
export const ITEM_TO_ROUTE_MAP: Record<SearchOptionsValue, string> = {
	contacts: `${MainRoutes.Organization}/${OrganizationRoute.Contacts}`,
	employees: `${MainRoutes.Organization}/${OrganizationRoute.Employees}`,
	companies: `${MainRoutes.Organization}/${OrganizationRoute.Companies}`,
	recipients: `${MainRoutes.Organization}/${OrganizationRoute.Recipients}`
};

export function searchDrawerNormalizer(
	item: SearchOptionsValue,
	data: Record<string, any>,
	searchTerms?: string
): SearchDrawerNormalizedData {
	const mappedParams: Params = mapParamsToRequest(data, ITEM_TO_PARAM_MAP[item]);
	return {
		route: ITEM_TO_ROUTE_MAP[item],
		searchParams: {
			[ParameterOptionValue.SearchTerms]: searchTerms,
			...data,
			[ParameterOptionValue.Client]: Array.isArray(data.client) ? data.client[0]?.id : data.client?.id,
			[ParameterOptionValue.Department]: data.department?.map(item => {
				return item.id;
			}),
			[ParameterOptionValue.Role]: data.role?.map(item => {
				return item.id;
			}),
			[ParameterOptionValue.Branch]: data.branch && data.branch[0] ? data.branch[0].id : null
		}
	};
}
